module.exports = __webpack_public_path__ + "img/pointE_bg_mob.c13fb388.png";